import type { ContentPublisherCreateIn } from '@/api/generated/schemas';

export type PublisherCreateValues = {
  [K in keyof ContentPublisherCreateIn]?: string | null;
};

/**
 * Trimmed form values with blank fields left out, so a cleared input never
 * stores an empty string on a publisher that cannot be edited afterwards.
 */
export const toPublisherCreatePayload = (
  values: PublisherCreateValues
): ContentPublisherCreateIn => {
  const optional: Partial<ContentPublisherCreateIn> = {};
  for (const [key, value] of Object.entries(values)) {
    const trimmed = typeof value === 'string' ? value.trim() : '';
    if (trimmed !== '')
      optional[key as keyof ContentPublisherCreateIn] = trimmed;
  }
  // The form requires a name; the backend rejects a blank one regardless.
  return { ...optional, name: optional.name ?? '' };
};

/** A cleared account input clears the account instead of storing ``''``. */
export const toDeliveryAccount = (value: string | null | undefined) =>
  value?.trim() || null;
